// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1px_j","infoBtn":"quickbooks_infoBtn__3xDlX","formBox":"quickbooks_formBox__2Gge3","formFooter":"quickbooks_formFooter__2pe2f"};